
var target;
var control;
import Swiper from 'Swiper';
import 'swiper/css/swiper.min.css';






var swipermp = new Swiper('.monphai-swiper', {
  grabCursor: true,
  centeredSlides: true,
  effect :"fade",
  pagination: {
    el: '.mp-pag',
    clickable: true,
  },
  loop: true,
  preloadImages: false,
  // Enable lazy loading
  lazy: {
    loadPrevNext: true,
  },
  slidesPerView: 1,
  autoplay: {
    delay: 5000,
  },
});
var swiperf5_thum;
if (!viewportIsMobile($("body").outerWidth())){
   swiperf5_thum = new Swiper('.swiper-f5-thum', {
    direction: 'vertical',
   
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      loadPrevNext: true,
    },
    slidesPerView: "auto",
  
  });
}
else{
   swiperf5_thum = new Swiper('.swiper-f5-thum', {
 
   
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      loadPrevNext: true,
    },
    slidesPerView: 2,
    centeredSlides:true,
    simulateTouch:true,
  });
  swiperf5_thum .on('slideChange', function () {
    $(".swiper-slide-thum").removeClass("active");
    $(".swiper-slide-thum").eq(swiperf5_thum.realIndex).click();
  
  });
}
var swiperf5 = new Swiper('.swiper-f5', {

  autoplay: {
    delay: 5000,
  },
  preloadImages: false,
  // Enable lazy loading
  lazy: {
    loadPrevNext: true,
  },
  slidesPerView: 1,
      navigation: {
      nextEl: '.f5-next',
      prevEl: '.f5-prev',
    },

});

var targetf5;
$( ".swiper-slide-thum" ).click(function(e) {
  e.preventDefault();
  targetf5 = $(this).data("target");
  swiperf5.slideTo(targetf5, 300 , false);
  swiperf5_thum.slideTo(targetf5, 300 , false);
  $(".swiper-slide-thum").removeClass("active");
  $(this).addClass("active");
});
swiperf5.on('slideChange', function () {
  $(".swiper-slide-thum").removeClass("active");
  $(".swiper-slide-thum").eq(swiperf5.realIndex).addClass("active");
  swiperf5_thum.slideTo(swiperf5.realIndex, 300 , false);

});
function viewportIsMobile(width){
  return (width < 1025);
}



// if ($('.section--5').length > 0) {
//   initSlideThumb('section--5');
// }

// function initSlideThumb(id) {
//   var selector = '.' + id;
//   var hloop;
//   var arraySlide = new Object();
//   var gallery = new Object();
//   var sliden;
//   if ($("body").outerWidth() < 1025) {
//     sliden = 1;
//     hloop = 1;
//   }
//   else {
//     sliden = 6;
//     hloop = 6;
//   }
//   gallery.top = new Swiper(selector + ' .swiper-f5', {
//     autoplay: {
//       delay: 9000,
//     },
//     speed: 600,
//     disableOnInteraction: true,
//     preventClicks: false,
//     loop: true,
//     loopedSlides: hloop,
//     navigation: {
//       nextEl: '.f5-next',
//       prevEl: '.f5-prev',
//     }, //looped slides should be the same
//   });

//   gallery.thumbs = new Swiper(selector + ' .swiper-f5-thum', {
//     slidesPerView: sliden,
//     touchRatio: 0.2,
//     direction: 'vertical',
//     loop: true,
//     loopedSlides: hloop, //looped slides should be the same
//     slideToClickedSlide: true,
//     disableOnInteraction: true,

//     // preventClicks: true,
//     preventClicks: false,
//     // freeMode: true,
//     // watchSlidesVisibility: true,
//     // watchSlidesProgress: true,
//   });

//   arraySlide.id = gallery;
//   arraySlide.id.top.controller.control = arraySlide.id.thumbs;
//   arraySlide.id.thumbs.controller.control = arraySlide.id.top;

// }
